var idSlider = 1;
$(document).ready( function(){
	// Slider
	if ( $(".slider").length ) {
		$(".slider").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			if ( $this_bloc.hasClass("entete") ) {
				$this_bloc.find(".slick-slider").slick({
				 	slide: "#" + idSliderSlider + " .item",
					adaptiveHeight: true,
					mobileFirst: true,
					autoplay: false,
					autoplaySpeed: 3000,
					speed: 600,
					useTransform: false,
					arrows: false,
					dots: true,
					cssEase: 'cubic-bezier(.3, .575, .225, 1)',
					slidesToShow: 1,
					slidesToScroll: 1
				});

				// Hauteur
				// var height = parseInt($(window).width() / 200 * 77);
				// $this_bloc.find(".item").height( height );
			}

			else {
				// Sinon, slider de contenu
				$this_bloc.find(".slick-slider").slick({
				 	slide: "#" + idSliderSlider + " .item",
					adaptiveHeight: true,
					mobileFirst: true,
					autoplay: false,
					autoplaySpeed: 6000,
					speed: 600,
					useTransform: false,
					arrows: true,
					prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
					nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
					cssEase: 'cubic-bezier(.3, .575, .225, 1)',
					slidesToShow: 1,
					slidesToScroll: 1
				});

				// Hauteur
				var height = parseInt($(window).width() / 200 * 77);
				$this_bloc.find(".item").height( height );
			}

			idSlider++;
		}); // each slider
	}

	// Slider Entête Home
	if ( $(".entete-home").length ) {
		$(".entete-home").each( function(e) {
			var $this_bloc = $(this);
			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);
			$this_bloc.find(".slick-slider").slick({
			 	slide: "#" + idSliderSlider + " .item",
				adaptiveHeight: false,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 400,
				useTransform: false,
				arrows: true,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				dots: false,
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				slidesToShow: 1,
				slidesToScroll: 1
			});

			idSlider++;
		}); // each slider
	}

	// Slider Entête Home
	if ( $(".entete-nous-rejoindre").length ) {
		$(".entete-nous-rejoindre").each( function(e) {
			var $this_bloc = $(this);
			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);
			$this_bloc.find(".slick-slider").slick({
			 	slide: "#" + idSliderSlider + " .item",
				adaptiveHeight: false,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 400,
				useTransform: false,
				arrows: true,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				dots: false,
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 760,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});

			idSlider++;
		}); // each slider
	}


	// Slider Home A la une
	if ( $(".home-a-la-une").length ) {
		$(".home-a-la-une").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			$this_bloc.find(".slick-slider").slick({
				adaptiveHeight: false,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 6000,
				speed: 600,
			  	variableWidth: true,
				useTransform: false,
				arrows: true,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				cssEase: 'cubic-bezier(.3, .575, .225, 1)'
			});

			idSlider++;
		}); // each slider
	}

	// Slider Home Cartes compétences
	if ( $(".home-cartes-competences").length ) {
		var blocHomeCardsSlick = [];
		$(".home-cartes-competences").each( function(e, index) {
			var $this_bloc = $(this);
			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".competences-slider").attr("id", idSliderSlider);
			var widthSlider = parseInt($this_bloc.find(".competences-slider .item").innerWidth()) * $this_bloc.find(".competences-slider .item").length;

			var settingsHomeCardsSlick = {
				adaptiveHeight: false,
				autoplay: false,
				autoplaySpeed: 6000,
				speed: 400,
				variableWidth: true,
				arrows: true,
				infinite: false,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				slidesToShow: 4,
				slidesToScroll: 2,
				responsive: [
					{
						breakpoint: 1110,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 980,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							variableWidth: false
						}
					}
				]
			};

			// Slider d'entête
			blocHomeCardsSlick[index] = $this_bloc.find(".competences-slider");
			if((($this_bloc.offset().left * 2) + 80 + widthSlider) >= $(window).width()) blocHomeCardsSlick[index].slick(settingsHomeCardsSlick);
			$(window).on('resize', function() {
				if((($this_bloc.offset().left * 2) + 80 + widthSlider) >= $(window).width()) {
					if(!blocHomeCardsSlick[index].hasClass('slick-initialized')) blocHomeCardsSlick[index].slick(settingsHomeCardsSlick);
				}else {
					if(blocHomeCardsSlick[index].hasClass('slick-initialized')) blocHomeCardsSlick[index].slick('unslick');
				}
			});

			idSlider++;
		}); // each slider
	}

	// Slider
	if ( $(".liste-cartes").length ) {
		$(".liste-cartes").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			$this_bloc.find(".slick-slider").slick({
			 	slide: "#" + idSliderSlider + " .item",
				// variableWidth: true,
				adaptiveHeight: true,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 6000,
				speed: 600,
				useTransform: false,
				arrows: true,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 760,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});

			idSlider++;
		}); // each slider
	}

	// Galerie photos
	if ( $(".galerie-photos").length ) {
		$(".galerie-photos").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			$this_bloc.find(".slick-slider").slick({
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 300,
				infinite: true,
				slidesToShow: 1,
				centerMode: true,
				variableWidth: true,
				//useTransform: false,
				arrows: true,
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow'></use></svg></a></div>",
				dots: true
			});
		});
	}


	// Home Témoignages
	if ( $(".home-temoignages").length ) {
		$(".home-temoignages").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			$this_bloc.find(".slick-slider").slick({
			 	slide: "#" + idSliderSlider + " .item",
				adaptiveHeight: true,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 600,
				useTransform: false,
				arrows: true,
				dots: false,
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>"
			});
		});
	}


	// Home Liste cartes numerotées
	if ( $(".liste-cartes-numerotees").length ) {
		$(".liste-cartes-numerotees").each( function(e) {
			var $this_bloc = $(this);

			var idSliderSlider = "slicker-slider-"+idSlider;
			$this_bloc.find(".slick-slider").attr("id", idSliderSlider);

			// Slider d'entête
			$this_bloc.find(".slick-slider").slick({
			 	slide: "#" + idSliderSlider + " .item",
				adaptiveHeight: true,
				mobileFirst: true,
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 600,
				useTransform: false,
				arrows: true,
				dots: false,
				cssEase: 'cubic-bezier(.3, .575, .225, 1)',
				prevArrow: "<div class='slick-left'><a href='#prev' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				nextArrow: "<div class='slick-right'><a href='#next' class='slick-control'><svg class='icon'><use xlink:href='"+nbDatas.siteurl+"/wp-content/themes/valorem/img/icons.svg#arrow-slider'></use></svg></a></div>",
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 520,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 760,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});
		});
	}

});

// Autoheight sur les blocs actu
// Correctif appliqué après le chargement de tous les éléments
window.onload = function () {
	if ( window.innerWidth >= 760 && $(".home-a-la-une").length ) {
		$(".home-a-la-une").each( function(e) {
			var height = $(this).find(".slick-list").height();
			$(this).find(".item").each(function(e) {
				$(this).height(height);
			});
		});
	}

	if ( $(".galerie-photos").length ) {
		$(".galerie-photos").each( function(e) {
			var base_height =	$(this).find(".item").height();
			$(this).find(".item img").each( function(e) {
				var width = $(this).width();
				var height = $(this).height();
				$(this).width( parseInt($(this).width()*base_height/$(this).height()) )
			});
		});
	}
}

$(document).ready( function () {
	$(".slick-control").click( function(e) {
		e.preventDefault();
	});
});
